import { useLayoutEffect, useRef } from 'react';
import {
  computePortraitScale,
  PORTRAIT_HEIGHT,
  PORTRAIT_WIDTH,
  setRootPortraitScale,
} from '../utils/portraitScale';

export { PORTRAIT_HEIGHT, PORTRAIT_WIDTH };

/**
 * Fits a 1080×1920 stage in the viewport. Type and spacing use --s,
 * which is 1 at 1080×1920 and scales with the screen.
 *
 * --s is set from JS (ResizeObserver) so kiosk WebViews that mishandle
 * CSS container-query units still get a valid scale.
 */
function PortraitStage({ children, className = '' }) {
  const viewportRef = useRef(null);
  const stageRef = useRef(null);

  useLayoutEffect(() => {
    const viewport = viewportRef.current;
    const stage = stageRef.current;
    if (!viewport || !stage) return undefined;

    const applyScale = () => {
      const scale = computePortraitScale(viewport.clientWidth, viewport.clientHeight);
      stage.style.setProperty('--s', String(scale));
      setRootPortraitScale(scale);
    };

    applyScale();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', applyScale);
      return () => window.removeEventListener('resize', applyScale);
    }

    const observer = new ResizeObserver(applyScale);
    observer.observe(viewport);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={viewportRef} className={`portraitViewport ${className}`.trim()}>
      <div ref={stageRef} className="portraitStage">
        {children}
      </div>
    </div>
  );
}

export default PortraitStage;
